import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Users, Settings, Heart, LogOut, 
  LayoutDashboard, Warehouse, MapPin, 
  Map, Building,MapIcon
} from 'lucide-react';

import useGlobale from './global';

const menuItems = [
  { 
    icon: MapIcon, 
    label: 'Carte',
    to: '/dashboard'
  },
  { 
    icon: LayoutDashboard, 
    label: 'Tableau de bord',
    to: '/stats/general'
  },
  
  
  { 
    icon: Building, 
    label: 'Statistiques par indicateur',
    to: '/stats/indicateurs'
  },
  { 
    icon: MapPin, 
    label: 'Statistiques par région',
    to: '/stats/regions'
  },
  { 
    icon: Map, 
    label: 'Statistiques par departement',
    to: '/stats/departements'
  },
  { 
    icon: Building, 
    label: 'Statistiques par commune',
    to: '/stats/communes'
  },
  { 
    icon: Warehouse, 
    label: 'Liste des dépôts',
    to: '/depots'
  },
  { 
    icon: Users, 
    label: 'Gestion des utilisateurs',
    to: '/utilisateurs'
  },
  // { 
  //   icon: Folder, 
  //   label: 'Gestion des rapports',
  //   to: '/rapports/create'
  // },
  { 
    icon: Settings, 
    label: 'Paramètres',
    to: '/settings'
  }
];

const Sidebar = ({ isSidebarOpen }) => {
  const location = useLocation();
  const logout = useGlobale(state => state.logout);

  const handleLogout = () => {
    // Ajoutez ici la logique de déconnexion
    // console.log('Logout clicked');
    logout();
  };

  return (
    <aside 
      className={`fixed lg:relative top-0 left-0 z-50 min-h-full 
      ${isSidebarOpen ? 'w-72' : 'w-20'} 
      transform duration-300 ease-in-out bg-gradient-to-b from-emerald-800 via-emerald-900 to-emerald-950`}
    >
      <div className="flex h-full flex-col">
        {/* Logo section modifiée */}
        <Link to="/dashboard" className="flex h-16 items-center px-6">
          <div className="flex items-center space-x-3">
            <img 
              src="/anrp.png" 
              alt="ANRP Logo" 
              className="h-10 w-auto bg-white p-1 rounded-lg" 
            />
            {isSidebarOpen && <span className="text-xl font-bold text-white">SIND</span>}
          </div>
        </Link>

        {/* Navigation */}
        <nav className="mt-8 px-4">
          {menuItems.map((item, idx) => {
            const isActive = location.pathname === item.to;
            
            return (
              <Link 
                key={idx}
                to={item.to}
                className={`flex items-center space-x-3 px-4 py-3 text-sm 
                ${isActive 
                  ? 'bg-white/20 text-white' 
                  : 'text-white/80 hover:bg-white/10'} 
                rounded-xl my-1 transition-colors`}
              >
                <div className="h-8 w-8 rounded-lg bg-white/5 flex items-center justify-center">
                  <item.icon className="h-5 w-5" />
                </div>
                {isSidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        {/* Section de déconnexion avec crédit développeur */}
        <div className="mt-auto">
          <div className="px-4 py-2 border-t border-emerald-700/50">
            {isSidebarOpen && (
              <a 
                href="https://aydees.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-xs text-emerald-300/80 hover:text-emerald-300 text-center py-2"
              >
                Développé par Aydées
              </a>
            )}
          </div>
          <div className="p-4">
            <button 
              onClick={handleLogout}
              className={`w-full flex items-center ${isSidebarOpen ? 'justify-start space-x-2' : 'justify-center'} 
                px-4 py-3 text-sm text-white/80 hover:bg-white/10 rounded-xl transition-colors`}
            >
              <LogOut className="h-5 w-5" />
              {isSidebarOpen && <span>Déconnexion</span>}
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;